import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionTitle } from "../ui";
import { ReplyBox } from "../ReplyBox";

export default function Submissions() {
  const [filter, setFilter] = useState("");
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => {
    api.get("/admin/submissions", { params: filter ? { type: filter } : {} }).then((res) => setRows(res.data));
  };
  useEffect(load, [filter]);

  return (
    <div data-testid="admin-submissions">
      <SectionTitle title="Submissions inbox" subtitle="Contact messages and quiz responses — reply directly from here using the site's email address." />
      <div className="flex gap-2 mb-5">
        {[["", "All"], ["contact", "Contact"], ["quiz", "Quiz"]].map(([val, label]) => (
          <button
            key={val}
            data-testid={`submissions-filter-${val || "all"}`}
            onClick={() => setFilter(val)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium border transition-colors ${
              filter === val ? "bg-sage text-white border-sage" : "bg-white text-charcoal-600 border-sand-200"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="rounded-xl bg-white border border-sand-200 overflow-hidden">
        {rows.length === 0 && <p className="p-6 text-sm text-charcoal-500">No submissions yet.</p>}
        {rows.map((r) => (
          <div key={r.id} className="border-b border-sand-100 last:border-0">
            <button
              data-testid={`submission-${r.id}`}
              onClick={() => setSelected(selected === r.id ? null : r.id)}
              className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-sand-50"
            >
              <div>
                <span className={`inline-block rounded-full px-2 py-0.5 text-[10px] uppercase tracking-wide mr-2 ${r.type === "quiz" ? "bg-sage-light text-sage-700" : "bg-terracotta-light text-terracotta-700"}`}>
                  {r.type}
                </span>
                <span className="text-sm font-medium text-charcoal-800">{r.name || r.email || "Anonymous"}</span>
                {r.email && <span className="text-sm text-charcoal-400 ml-2">{r.email}</span>}
                {(r.replied || r.status === "replied") && <span className="ml-2 rounded-full bg-sage/15 px-2 py-0.5 text-[10px] uppercase tracking-wide text-sage-700">replied</span>}
              </div>
              <span className="text-xs text-charcoal-400">{new Date(r.created_at).toLocaleString()}</span>
            </button>
            {selected === r.id && (
              <div className="px-5 pb-5 text-sm text-charcoal-600 space-y-1">
                {r.type === "contact" ? (
                  <>
                    <p><b>Inquiry type:</b> {r.inquiry_type === "support" ? "Problem / support issue" : r.inquiry_type === "quote" ? "Quote / moving question" : "General inquiry"}</p>
                    <p><b>Phone:</b> {r.phone || "—"}</p>
                    <p><b>Move:</b> {r.move_from || "—"} → {r.move_to || "—"}</p>
                    <p><b>Timeline:</b> {r.timeline || "—"}</p>
                    <p className="whitespace-pre-line mt-2 rounded-lg bg-sand-50 p-3"><b>Message:</b> {r.message}</p>
                  </>
                ) : (
                  <>
                    <p><b>Answers:</b> {Object.entries(r.answers || {}).map(([k, v]) => `${k}: ${v}`).join(", ")}</p>
                    <p><b>Recommended:</b> {(r.recommended || []).join(", ") || "—"}</p>
                  </>
                )}
                <ReplyBox email={r.email} replies={r.replies} endpoint={`/admin/submissions/${r.id}/reply`} onSent={load} testId={`submission-${r.id}`} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
